<template>

  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;" class="rt_bg">

    <el-header class="headerManu">
      <div style="height: 60px;background-color: transparent;float: left; margin-left: 20px; display: flex;flex-direction: row;justify-content: start;" @click="goHome()">
        <img  :src="logo"  style="float: left;width: 40px;height: 40px;margin-top: 10px;margin-left: 10px;"/>
        <div style="background-color: transparent;
          font-family: 'Microsoft YaHei';
          color: white; height: 60px; display: flex;
          flex-direction: column;justify-content: start; padding-left: 10px;">
          <div class="BSD_TITLE">Global Change Risk Map Platform</div>
          <div class="BSD_SUBTITLE">of Population and Economic Systems</div>
        </div>
      </div>
    </el-header>


    <el-main id="router_view"
             style="background-color: transparent;width: 100%;
             height: calc(100vh-60px);
             text-align: center; font-family: 'PingFangSC-Medium'">

      <el-row style="background-color: transparent;width: 100%;height: 100vh">
        <el-col :span=12 style="background-color: transparent;height: 100vh; font-family: HelveticaLT-Black;" >
          <div style="margin-left: 8.3vw;margin-top: 10vh;" class="c_left_title">
            The Global Change <br/> Risk Map Platform of <br/> Population and <br/>  Economic Systems
          </div>
          <div  style="margin-left: 8.3vw; margin-top:4vh;" class="c_left_subTitle">
            Global Change Risk Map Platform of Population and Economic Systems is a digital risk map platform that offers readers the systematic research results of the project <a href="http://gcr.bnu.edu.cn/?page_id=8]" target="_blank;" class="c_a">“Global Change Risk of Population and Economic Systems: Mechanisms and Assessments”</a> (Grant no. 2016YFA0602400).
<!--            <a href="http://gcr.bnu.edu.cn/?page_id=8]" target="_blank;" class="c_a">-->
<!--              “Global Change Risk of Population and Economic Systems: Mechanisms and Assessments” (Grant no. 2016YFA0602400).-->
<!--            </a>-->
          </div>
          <div class="css_button" @click="switchNext">
            Start Analysis
          </div>

          <div v-show="visite_num!=undefined"
               style="margin-left: 8.3vw;
               width: 150px;
               color: white;
               text-align: right;
               line-height: 55px;
               height: 55px;">
            <span class="css_visite">{{visite_num}}</span>
          </div>

        </el-col>
        <el-col :span=12 style="background-color: transparent;height: 100vh;">
          <img src="http://bunjs.aiside.top/img_logged.png" style="width: 100%;"/>
        </el-col>
      </el-row>
    </el-main>

  </el-container>
</template>

<script>

  import { api_bnu_readVisiteNums } from "@/api";
  import {Notify} from "vant";

  import { api_bnu_login } from "@/api";
  let bsd_logo =  require( '../../../src/assets/icons/earth.png');
  export default {
    name: "Main",
    data(){
      return {
        logo:bsd_logo,
        loginData:{
          mail:undefined,
          password:undefined
        },
        visite_num:undefined
      }
    },
    methods:{
      goHome(){
        this.$router.push({path:'/BNUMap/main/Introduction'})
      },
      switchNext(){
        console.log("next");
        let ls_guide = localStorage.getItem("ls_guide");
        if(ls_guide!=undefined && ls_guide=="1"){
          console.log("next=1");
          this.$router.push({path:'/BNUMap/main/Introduction'})
        }else {
          console.log("next=2");
          this.$router.push({path:'/BNUMap/guide'})
        }
      },
      /**
       *
       * */
      sigin(){
        if(this.loginData.mail==undefined || this.loginData.mail.length==0){
          this.$message({
            type: 'info',
            message: 'Please Enter Email Address'
          });
          return;
        }
        if(this.loginData.password==undefined || this.loginData.password.length==0){
          this.$message({
            type: 'info',
            message: 'Please Enter Password'
          });
          return;
        }
        console.log("user login && param = ",this.loginData);
        let _this = this;
        api_bnu_login(this.loginData).then(res=>{
          let resData = res.data;
          let userData = resData.data;
          this.$appStorage.storeUserData(userData);
          console.log("resData = ",resData);
          if(resData.code==200000){
            _this.goHome();
          }else
          {
            _this.$alert(resData.msg?resData.msg:"The account or password is incorrect, please re-enter！", 'Prompt', {
              confirmButtonText: 'OK',

            });
          }
        }).catch(() => {
          Notify({ type: "danger", message: "请求失败" });
        });

      }
    },

    mounted() {

      api_bnu_readVisiteNums().then(res=>{
        let rData = res.data;
        console.log("rData = ",rData);
        this.visite_num = rData.data+" visits";
      })



    }
  }
</script>




<style scoped lang="scss">
@import "BSDMap";


.css_visite{
  font-family: Calibri;
  font-weight: normal;
  font-size: 1.7rem
}

.BSD_TITLE{
  margin-top: 12px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}
.BSD_SUBTITLE{
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}


.css_button
{
  margin-top: 6vh;cursor: pointer;
  margin-left: 8.3vw;
  width:150px;
  height: 5.3vh;
  line-height: 5.3vh;text-align:
  center;font-size: 16px;color: white;font-family: 'Microsoft YaHei';
  background-image: linear-gradient(180deg, #34B859 0%, #2EA54F 100%);
  border-radius: 3px;
}

.rt_bg{
  background-image: linear-gradient(133deg, #042B64 0%, #040C21 53%, #06275F 87%, #451E49 100%);
}

.c_left_title{
  font-family: "Microsoft YaHei";
  font-size: 36px;
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 54px;
  text-align: left;
  font-weight: bolder;
}
.c_left_subTitle{
  font-family: "Microsoft YaHei";
  font-size: 15px;
  color: #899DBB;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
  width: 34vw;
}
.c_a
{
  font-family: "Microsoft YaHei";
  font-size: 15px;
  color: deepskyblue;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
  font-weight: bold;
  font-style: italic;
}


.headerManu{
 cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/Main.vue